import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

export const overAllSummaryColumns = [
  { field: "standard", header: "Standard", minWidth: "14rem" },
  { field: "vendor", header: "Vendor", minWidth: "8rem" },
  { field: "logistics", header: "Logistics", minWidth: "8rem" },
  { field: "go", header: "GO", minWidth: "8rem" },
  { field: "totalEdi", header: "Total EDI", minWidth: "8rem" },
  { field: "total", header: "Total", minWidth: "18rem" }
];

export const deliColumns = [
  {
    field: "standardCredit",
    header: "Standard Credit",
    minWidth: "8rem",
    group: "deli"
  },
  { field: "vendor", header: "Vendor", minWidth: "8rem", group: "deli" },
  { field: "logistics", header: "Logistics", minWidth: "8rem", group: "deli" },
  { field: "goFees", header: "GO Fees", minWidth: "8rem", group: "deli" },
  { field: "totalEdi", header: "Total EDI", minWidth: "8rem", group: "deli" }
];

export const produceColumns = [
  {
    field: "standardCredit",
    header: "Standard Credit",
    minWidth: "8rem",
    group: "produce"
  },
  { field: "vendor", header: "Vendor", minWidth: "8rem", group: "produce" },
  {
    field: "logistics",
    header: "Logistics",
    minWidth: "8rem",
    group: "produce"
  },
  { field: "goFees", header: "GO Fees", minWidth: "8rem", group: "produce" },
  { field: "totalEdi", header: "Total EDI", minWidth: "8rem", group: "produce" }
];

export const retailColumns = [
  {
    field: "creditRetailGrandTotal",
    header: "Credit Retail Grand Total",
    minWidth: "10rem",
    group: "krogerRetail"
  }
];

export const regionSummaryColumns = [
  { field: "storeName", header: "Store Name", minWidth: "10rem" },
  ...deliColumns,
  ...produceColumns,
  {
    field: "creditGrandTotal",
    header: "Credit Grand Total",
    minWidth: "9rem"
  },
  ...retailColumns
];

export const createRegionSummaryHeaderGroup = (visibleColumns) => {
  const deli = visibleColumns?.filter((column) => column.group === "deli");
  const produce = visibleColumns?.filter(
    (column) => column.group === "produce"
  );
  const retail = visibleColumns?.filter(
    (column) => column.group === "krogerRetail"
  );

  const storeColumn = visibleColumns?.find(
    (column) => column.field === "storeName"
  );

  const grandTotalColumn = visibleColumns?.find(
    (column) => column.field === "creditGrandTotal"
  );

  return (
    <ColumnGroup>
      <Row>
        {storeColumn && <Column header="Store Name" rowSpan={2} />}
        {deli?.length > 0 && (
          <Column
            header="Deli"
            colSpan={deli.length}
            headerClassName="deliHeader"
          />
        )}
        {produce?.length > 0 && (
          <Column
            header="Produce"
            colSpan={produce.length}
            headerClassName="produceHeader"
          />
        )}
        {grandTotalColumn && <Column header="Credit Grand Total" rowSpan={2} />}
        {retail?.length > 0 && (
          <Column
            header="Kroger Retail"
            colSpan={retail.length}
            headerClassName="retailHeader"
          />
        )}
      </Row>
      <Row>
        {deli?.map((column) => (
          <Column key={`deli-${column.field}`} header={column.header} />
        ))}

        {produce?.map((column) => (
          <Column key={`produce-${column.field}`} header={column.header} />
        ))}
        {retail?.map((column) => (
          <Column
            key={`retail-${column.field}`}
            header={column.header}
            headerClassName="retailSubHeader"
          />
        ))}
      </Row>
    </ColumnGroup>
  );
};

export const freshKitchenDeliColumns = [
  {
    field: "storeNumber",
    header: "Store#",
    minWidth: "8rem",
    group: "kitchenDeli"
  },
  {
    field: "invoiceNumber",
    header: "Invoice#",
    minWidth: "8rem",
    group: "kitchenDeli"
  },
  {
    field: "invoiceDate",
    header: "Invoice Date",
    minWidth: "8rem",
    group: "kitchenDeli"
  },
  {
    field: "creditReason",
    header: "Credit Reason",
    minWidth: "8rem",
    group: "kitchenDeli"
  },
  {
    field: "denialReason",
    header: "Denial Reason",
    minWidth: "8rem",
    group: "kitchenDeli"
  },
  { field: "vendor", header: "Vendor", minWidth: "8rem", group: "kitchenDeli" },
  {
    field: "logistics",
    header: "Logistics",
    minWidth: "8rem",
    group: "kitchenDeli"
  },
  { field: "go", header: "Go", minWidth: "8rem", group: "kitchenDeli" },
  {
    field: "reversalDate",
    header: "Reversal Date",
    minWidth: "8rem",
    group: "kitchenDeli"
  }
];

export const freshKitchenProduceColumns = [
  {
    field: "storeNumber",
    header: "Store#",
    minWidth: "8rem",
    group: "kitchenProduce"
  },
  {
    field: "invoiceNumber",
    header: "Invoice#",
    minWidth: "8rem",
    group: "kitchenProduce"
  },
  {
    field: "invoiceDate",
    header: "Invoice Date",
    minWidth: "8rem",
    group: "kitchenProduce"
  },
  {
    field: "creditReason",
    header: "Credit Reason",
    minWidth: "8rem",
    group: "kitchenProduce"
  },
  {
    field: "denialReason",
    header: "Denial Reason",
    minWidth: "8rem",
    group: "kitchenProduce"
  },
  {
    field: "vendor",
    header: "Vendor",
    minWidth: "8rem",
    group: "kitchenProduce"
  },
  {
    field: "logistics",
    header: "Logistics",
    minWidth: "8rem",
    group: "kitchenProduce"
  },
  { field: "go", header: "Go", minWidth: "8rem", group: "kitchenProduce" },
  {
    field: "reversalDate",
    header: "Reversal Date",
    minWidth: "8rem",
    group: "kitchenProduce"
  }
];

export const storeRetailColumn = [
   {
    field: "storeNumber",
    header: "Store#",
    minWidth: "8rem",
    group: "kitchenRetail"
  },
  {
    field: "invoiceNumber",
    header: "Invoice#",
    minWidth: "8rem",
    group: "kitchenRetail"
  },
  {
    field: "invoiceDate",
    header: "Invoice Date",
    minWidth: "8rem",
    group: "kitchenRetail"
  },
  {
    field: "totalCredit",
    header: "Total Credit($)",
    minWidth: "8rem",
    group: "kitchenRetail"
  }
];

export const storeSummaryColumns = [
  { field: "divName", header: "Div Name", minWidth: "10rem" },
  { field: "date", header: "Date", minWidth: "10rem" },
  ...freshKitchenDeliColumns,
  ...freshKitchenProduceColumns,
  ...storeRetailColumn
];

export const createStoreSummaryHeaderGroup = (visibleColumns) => {
  const kitchenDeli = visibleColumns?.filter(
    (column) => column.group === "kitchenDeli"
  );
  const kitchenProduce = visibleColumns?.filter(
    (column) => column.group === "kitchenProduce"
  );
  const kitchenRetail = visibleColumns?.filter(
    (column) => column.group === "kitchenRetail"
  );
  const divColumn = visibleColumns?.find(
    (column) => column.field === "divName"
  );

  const dateColumn = visibleColumns?.find((column) => column.field === "date");

  return (
    <ColumnGroup>
      <Row>
        {divColumn && <Column header="Div Name" rowSpan={2} />}
        {dateColumn && <Column header="Date" rowSpan={2} />}
        {kitchenDeli?.length > 0 && (
          <Column
            header="Deli"
            colSpan={kitchenDeli.length}
            headerClassName="deliHeader"
          />
        )}
        {kitchenProduce?.length > 0 && (
          <Column
            header="Produce"
            colSpan={kitchenProduce.length}
            headerClassName="produceHeader"
          />
        )}
        {kitchenRetail?.length > 0 && (
          <Column
            header="Kroger Retail"
            colSpan={kitchenRetail.length}
            headerClassName="retailHeader"
          />
        )}
      </Row>
      <Row>
        {kitchenDeli?.map((column) => (
          <Column key={`deli-${column.field}`} header={column.header} />
        ))}

        {kitchenProduce?.map((column) => (
          <Column key={`produce-${column.field}`} header={column.header} />
        ))}
        {kitchenRetail?.map((column) => (
          <Column
            key={`retail-${column.field}`}
            header={column.header}
            headerClassName="retailSubHeader"
          />
        ))}
      </Row>
    </ColumnGroup>
  );
};

export const itemSummaryColumns = [
  {
    field: "date",
    header: "Date",
    minWidth: "8rem"
  },
  {
    field: "region",
    header: "Region",
    minWidth: "8rem"
  },
  {
    field: "store",
    header: "Store",
    minWidth: "12rem"
  },
  {
    field: "invoiceNumber",
    header: "Invoice#",
    minWidth: "12rem"
  },
  {
    field: "creditReason",
    header: "Credit Reason",
    minWidth: "10rem"
  },
  {
    field: "totalInvoice",
    header: "Total Invoice",
    minWidth: "8rem"
  },
  {
    field: "lineAmountTotal",
    header: "Total Line Amount",
    minWidth: "8rem"
  }
];

export const itemSummaryExpansionColumns = [
  {
    field: "extItemId",
    header: "Ext Item ID",
    minWidth: "8rem"
  },
  {
    field: "tfItemId",
    header: "TF Item ID",
    minWidth: "8rem"
  },
  {
    field: "qty",
    header: "Quantity",
    minWidth: "8rem"
  },
  {
    field: "uom",
    header: "UOM",
    minWidth: "8rem"
  },
  {
    field: "salesPrice",
    header: "Sales Price",
    minWidth: "8rem"
  },
  {
    field: "lineAmount",
    header: "Line Amount",
    minWidth: "8rem"
  },
]

export const billbackDeliColumns = [
  {
    field: "storeNumber",
    header: "Store#",
    minWidth: "8rem",
    group: "billbackDeli"
  },
  {
    field: "invoiceNumber",
    header: "Invoice#",
    minWidth: "8rem",
    group: "billbackDeli"
  },
  {
    field: "invoiceDate",
    header: "Invoice Date",
    minWidth: "8rem",
    group: "billbackDeli"
  },
  {
    field: "creditReason",
    header: "Credit Reason",
    minWidth: "8rem",
    group: "billbackDeli"
  },
  {
    field: "denialReason",
    header: "Denial Reason",
    minWidth: "8rem",
    group: "billbackDeli"
  },
  { field: "vendor", header: "Vendor", minWidth: "8rem", group: "billbackDeli" },
  {
    field: "logistics",
    header: "Logistics",
    minWidth: "8rem",
    group: "billbackDeli"
  },
  { field: "go", header: "Go", minWidth: "8rem", group: "billbackDeli" },
  {
    field: "reversalDate",
    header: "Reversal Date",
    minWidth: "8rem",
    group: "billbackDeli"
  }
];

export const billbackProduceColumns = [
  {
    field: "storeNumber",
    header: "Store#",
    minWidth: "8rem",
    group: "billbackProduce"
  },
  {
    field: "invoiceNumber",
    header: "Invoice#",
    minWidth: "8rem",
    group: "billbackProduce"
  },
  {
    field: "invoiceDate",
    header: "Invoice Date",
    minWidth: "8rem",
    group: "billbackProduce"
  },
  {
    field: "creditReason",
    header: "Credit Reason",
    minWidth: "8rem",
    group: "billbackProduce"
  },
  {
    field: "denialReason",
    header: "Denial Reason",
    minWidth: "8rem",
    group: "billbackProduce"
  },
  {
    field: "vendor",
    header: "Vendor",
    minWidth: "8rem",
    group: "billbackProduce"
  },
  {
    field: "logistics",
    header: "Logistics",
    minWidth: "8rem",
    group: "billbackProduce"
  },
  { field: "go", header: "Go", minWidth: "8rem", group: "billbackProduce" },
  {
    field: "reversalDate",
    header: "Reversal Date",
    minWidth: "8rem",
    group: "billbackProduce"
  }
];

export const billbackRetailColumn = [
  {
    field: "storeNumber",
    header: "Store#",
    minWidth: "8rem",
    group: "billbackRetail"
  },
  {
     field: "invoiceNumber",
    header: "Invoice#",
    minWidth: "8rem",
    group: "billbackRetail"
  },
  {
    field: "invoiceDate",
    header: "Invoice Date",
    minWidth: "8rem",
    group: "billbackRetail"
  },
  {
    field: "totalCredit",
    header: "Total Credit($)",
    minWidth: "8rem",
    group: "billbackRetail"
  }
];

export const billbackSummaryColumns = [
  { field: "date", header: "Date", minWidth: "4rem" },
  { field: "divName", header: "Div Name", minWidth: "6rem" },
  ...billbackDeliColumns,
  ...billbackProduceColumns,
  ...billbackRetailColumn
];

export const createBillbackSummaryHeaderGroup = (visibleColumns, showSelection = false) => {
  const billbackDeli = visibleColumns?.filter(
    (column) => column.group === "billbackDeli"
  );
  const billbackProduce = visibleColumns?.filter(
    (column) => column.group === "billbackProduce"
  );
  const billbackRetail = visibleColumns?.filter(
    (column) => column.group === "billbackRetail"
  );
  const billbackDateColumn = visibleColumns?.find((column) => column.field === "date");
  const billbackDivColumn = visibleColumns?.find(
    (column) => column.field === "divName"
  );
 

  return (
    <ColumnGroup>
      <Row>
        {showSelection && (
          <Column header="" rowSpan={2} style={{ width: "3rem" }} />
        )}
        {billbackDateColumn && <Column header="Date" rowSpan={2} />}
        {billbackDivColumn && <Column header="Div Name" rowSpan={2} />}
        {billbackDeli?.length > 0 && (
          <Column
            header="Deli"
            colSpan={billbackDeli.length}
            headerClassName="deliHeader"
          />
        )}
        {billbackProduce?.length > 0 && (
          <Column
            header="Produce"
            colSpan={billbackProduce.length}
            headerClassName="produceHeader"
          />
        )}
        {billbackRetail?.length > 0 && (
          <Column
            header="Kroger Retail"
            colSpan={billbackRetail.length}
            headerClassName="retailHeader"
          />
        )}
      </Row>
      <Row>
        {billbackDeli?.map((column) => (
          <Column key={`deli-${column.field}`} header={column.header} />
        ))}

        {billbackProduce?.map((column) => (
          <Column key={`produce-${column.field}`} header={column.header} />
        ))}
        {billbackRetail?.map((column) => (
          <Column
            key={`retail-${column.field}`}
            header={column.header}
            headerClassName="retailSubHeader"
          />
        ))}
      </Row>
    </ColumnGroup>
  );
};